import React, { useState } from 'react';
import { message } from 'antd';
import ToggleSwitch from '../../../../../CommonComponents/ToggleSwitch/ToggleSwitch';
import '../stylesEditingMode.css';
import createPrivateAdminPanelInstance from '../../../../../../api/PrivateAdminPanelInstance';
import { API_ROUTES } from '../../../../../../api/ApiRoutes';
import RebetLoader from '../../../../../CommonComponents/RebetLoader/RebetLoader';
import { NumericFormat } from 'react-number-format';
import { validateRebetCash, validateRebetCoins } from '../../../../../../utils/Validation';
import { handleRebetCashChange, handleRebetCoinChange, updateCashSwitch, updateCoinSwitch } from '../../../../../../utils/PersonalLimits/Handlers';
import { AppStrings } from '../../../../../../utils/constants/AppStrings';
import { getApiErrorMessage } from '../../../../../../utils/ErrorUtils';

function EditLossLimitsPopup({ getUserPersonalLimit, userId, showPersonalLimits, limits }) {
  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(token?.AccessToken);

  const [rebetCoins, setRebetCoins] = useState(Number(limits.rebetCoins));
  const [rebetCash, setRebetCash] = useState(Number(limits.rebetCash));
  const [coinSwitch, setCoinSwitch] = useState(limits.rebetCoins);
  const [cashSwitch, setCashSwitch] = useState(limits.rebetCash);
  const [isApiRunning, setIsApiRunning] = useState(false);
  const [rebetCoinsError, setRebetCoinsError] = useState('');
  const [rebetCashError, setRebetCashError] = useState('');

  const editLossLimits = async () => {
    if (!userId) return;

    const isRebetCoinsValid = validateRebetCoins(rebetCoins, coinSwitch, setRebetCoinsError);
    const isRebetCashValid = validateRebetCash(rebetCash, cashSwitch, setRebetCashError);

    if (!isRebetCoinsValid || !isRebetCashValid) {
      return;
    }

    setIsApiRunning(true);

    const params = {
      user_id: userId,
      // user_personal_limit: {
      max_coin_loss_per_day: coinSwitch ? Number(rebetCoins) : false,
      max_cash_loss_per_day: cashSwitch ? Number(rebetCash) : false,
      // },
    };

    try {
      await PrivateAdminPanelInstance.patch(API_ROUTES.SET_USERS_PERSONAL_LIMIT?.replace("{user_id}", params?.user_id), params);
      await getUserPersonalLimit(true);
      message.success(AppStrings.LIMITS_UPDATED_SUCCESSFULLY);
    } catch (error) {
      console.error('Error editing loss limits: ', error);
      message.error(getApiErrorMessage(error, AppStrings.ERROR_PROCESSING_REQUEST));
    } finally {
      setIsApiRunning(false);
    }
  };

  return (
    <div className='editing-mode'>
      <div className='personal-limits-section-container'>
        <div className='personal-limits-section-body'>
          <div className='personal-limits-section-item border-bottom'>
            <div>
              <div className='personal-limits-section-item-label'>
                {AppStrings.MAX_AMOUNT_OF_SECONDARY_CURRENCY_YOU} <br /> {AppStrings.WILL_ALLOW_YOURSELF_TO_LOSE_EACH_DAY}
                <ToggleSwitch status={coinSwitch} eventCode={''}
                  updateEventCode={() => updateCoinSwitch(setCoinSwitch, setRebetCoinsError)} />
              </div>
              <div className='personal-limits-section-item-value'>
                <NumericFormat
                  className={!coinSwitch ? 'disabled' : ''}
                  value={rebetCoins}
                  thousandSeparator={true}
                  prefix={AppStrings.COUNTRY_CURRENCY_SYMBOL}
                  decimalScale={0}
                  onValueChange={(value) => handleRebetCoinChange(value, setRebetCoins, coinSwitch, setRebetCoinsError)}
                  disabled={!coinSwitch}
                />
                {rebetCoinsError && <div className='error-message'>{rebetCoinsError}</div>}
              </div>
            </div>
          </div>
          <div className='personal-limits-section-item border-bottom'>
            <div>
              <div className='personal-limits-section-item-label'>
                {AppStrings.MAX_AMOUNT_OF_PRIMARY_CURRENCY_YOU} <br /> {AppStrings.WILL_ALLOW_YOURSELF_TO_LOSE_EACH_DAY}
                <ToggleSwitch status={cashSwitch} eventCode={''}
                  updateEventCode={() => updateCashSwitch(setCashSwitch, setRebetCashError)} />
              </div>
              <div className='personal-limits-section-item-value'>
                <NumericFormat
                  className={!cashSwitch ? 'disabled' : ''}
                  value={rebetCash}
                  thousandSeparator={true}
                  prefix={AppStrings.COUNTRY_CURRENCY_SYMBOL}
                  decimalScale={0}
                  onValueChange={(value) => handleRebetCashChange(value, setRebetCash, cashSwitch, setRebetCashError)}
                  disabled={!cashSwitch}
                />
                {rebetCashError && <div className='error-message'>{rebetCashError}</div>}
              </div>
            </div>
          </div>
          <div className='buttons'>
            <button className='close-button' onClick={showPersonalLimits}>{AppStrings.BACK}</button>
            <button
              className={`save-button ${isApiRunning ? 'saving' : ''} ${rebetCashError || rebetCoinsError ? 'disabled' : ''}`}
              disabled={isApiRunning || rebetCashError || rebetCoinsError}
              onClick={editLossLimits}>
              {isApiRunning ? <RebetLoader height={'20px'} width={'20px'} /> : AppStrings.SAVE}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditLossLimitsPopup;
